module.exports = __webpack_public_path__ + "static/media/photoshop.730c6706.svg";